var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarHomeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.75 0C48.5478 15.7927 56.0215 28.0709 69.0594 36.9927C75.231 41.216 81.8823 44.2887 89.4541 45.0545C90.2929 45.1393 91.0656 45.8774 92.2505 46.5193C69.768 49.7892 52.7428 65.374 47.1539 87.6667C46.7997 89.0794 47.0376 90.6405 47 92.5663C47 93 46.5 93 46.2456 92.5914C44.1351 84.0367 42.0101 76.0613 37.0523 69.0402C27.9363 56.1305 15.9166 48.3534 0 47C0 46.5556 -5.96046e-08 46.1111 0.352688 45.6645C13.279 43.7254 23.9866 38.2646 32.6521 28.8677C40.212 20.6697 44.0301 10.7688 46 0C46 0 46.5 0 46.75 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHomeWhite);
export default __webpack_public_path__ + "static/media/StarHomeWhite.2f4f276ae1f93b671b524771c5f66163.svg";
export { ForwardRef as ReactComponent };